// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610161715/js/" + chunkId + "." + {"44":"3d6dd46c","225":"04265448","481":"2a72c1f7","486":"72cf13c2","770":"c537be31"}[chunkId] + ".0.4146934499904008.chunk.js";
};